import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillTosDataView, getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTos from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTos";
import updateSearchFields from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/UpdateSearchFields";
import updateBillTosSearchFields from "@insite/client-framework/Store/Pages/RfqMyQuotes/Handlers/UpdateBillTosSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import DynamicDropdown, { DynamicDropdownPresentationProps, OptionObject } from "@insite/mobius/DynamicDropdown";
import { FormInputWrapper } from "@insite/mobius/FormField/FormField";
import Select, { SelectProps } from "@insite/mobius/Select";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import debounce from "lodash/debounce";
import truncate from "lodash/truncate";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const { getBillTosParameter } = state.pages.rfqMyQuotes;
    return {
        // billTosDataView: getBillTosDataView(state, {}),
        billTosDataView: getBillTosParameter && getBillTosDataView(state, getBillTosParameter),
        parameter: state.pages.invoiceHistory.getInvoicesParameter,
        contextBillTo: state.context.session,
        settings: getSettingsCollection(state),
        getBillTosParameter,
        billToState: getBillToState(state, state.context.session.billToId),
    };
};

const mapDispatchToProps = {
    updateSearchFields,
    loadBillTos,
    updateBillTosSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistorySearchFieldShipToStyles {
    select?: SelectProps;
    wrapper?: InjectableCss;
    optionText?: TypographyPresentationProps;
    billToSelectorDynamicDropdown?: DynamicDropdownPresentationProps;
}

export const shipToStyles: OrderHistorySearchFieldShipToStyles = {
    wrapper: {
        css: css`
            width: 100%;
            padding: 1.5rem;
            background-color: #f1f1f1;
        `,
    },
    select: {
        cssOverrides: {
            formField: css`
                label {
                    width: 200px;
                }
                ${FormInputWrapper} {
                    max-width: 360px;
                    option {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        max-width: 360px;
                    }
                }
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                flex-direction: column;
                                label {
                                    width: 100%;
                                    text-align: left;
                                    margin-bottom: 5px;
                                }
                                ${FormInputWrapper} {
                                    max-width: 360px;
                                    width: 100%;
                                }
                            `,
                            css`
                                flex-direction: column;
                                label {
                                    width: 100%;
                                    text-align: left;
                                    margin-bottom: 5px;
                                }
                                ${FormInputWrapper} {
                                    max-width: 360px;
                                    width: 100%;
                                }
                            `,
                            null,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            `,
        },
    },
    optionText: {
        ellipsis: true,
        css: css`
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 360px;
        `,
    },
};
const styles = shipToStyles;

// class InvoiceHistorySearchFieldBillTo extends React.Component<Props> {
//     state = {
//         defaulSelectValue: -1,
//     }

//     componentDidMount() {
//         if (!this.props.billTosDataView.value) {
//             this.props.loadBillTos();
//         }
//         setTimeout(() => {
//             const billToOptions = this.props.billTosDataView.value || [];
//             const billToId = this.props.contextBillTo.billToId;
//             const extractingCurrentId = billToOptions.find((val)=>{
//                 return val.id === billToId;
//             });
//             const defaultVal = extractingCurrentId ? extractingCurrentId.customerNumber : undefined;
//             this.setState({defaulSelectValue: defaultVal})
//             this.props.updateSearchFields({ customerNumber: defaultVal } as GetInvoicesApiParameter)
//         }, 2000);
//     }

//     selectCustomerHandler = (billToId?: string) => {
//         this.props.updateSearchFields({ customerNumber: billToId } as GetInvoicesApiParameter);
//         this.setState({defaulSelectValue: billToId })
//     };

//     render() {
//         const billToOptions = this.props.billTosDataView.value || [];
//         const options: OptionObject[] = [{
//             optionText: "All",
//             optionValue: "-1"
//         },
//         ...billToOptions.map(billTo => ({
//             optionText: billTo.label,
//             optionValue: billTo.customerNumber,
//         }))];
//         return (
//             <StyledWrapper {...styles.wrapper}>
//                 <StyledWrapper
//                     css={css`
//                         width: 50%;
//                         max-width: 1440px;
//                     `}
//                 >
//                     <DynamicDropdown
//                         label={translate("Select Customer Account")}
//                         {...styles.billToSelectorDynamicDropdown}
//                         onSelectionChange={this.selectCustomerHandler}
//                         selected={(this.props.parameter as any).customerNumber || this.state.defaulSelectValue}
//                         options={options}
//                         placeholder={translate("Search or Select Bill To")}
//                         data-test-selector="changeCustomerBillToSelectorInvoiceHistory"
//                         filterOption={() => true}
//                     />
//                 </StyledWrapper>
//             </StyledWrapper>
//         );
//     }
// }

const InvoiceHistorySearchFieldBillTo = ({
    billTosDataView,
    getBillTosParameter,
    loadBillTos,
    updateBillTosSearchFields,
    updateSearchFields,
    settings,
    contextBillTo,
    billToState,
    parameter,
}: Props) => {
    const [billToOptions, setBillToOptions] = React.useState<OptionObject[]>([]);
    const [billToSearch, setBillToSearch] = React.useState("");
    const EMTPY_ID = "-1";

    React.useEffect(() => {
        loadBillTos(getBillTosParameter);
    }, []);
    React.useEffect(() => {
        if (billTosDataView?.value) {
            const billToOptions = getBillToOptions();
            setBillToOptions(billToOptions);
        } else if (billTosDataView && !billTosDataView.value && !billTosDataView.isLoading) {
            loadBillTos(getBillTosParameter);
        }
    }, [billTosDataView]);

    React.useEffect(() => {
        if (billToState.value) {
            updateSearchFields({
                customerNumber:
                    billToState.value.customerNumber === EMTPY_ID || !billToState.value.customerNumber
                        ? ""
                        : billToState.value.customerNumber,
            } as GetInvoicesApiParameter);
        }
    }, [billToState]);

    const changeCustomerSearchTextHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.currentTarget.value;
        setBillToSearch(value);
        debouncedUpdateBillTosSearchFields(value);
    };

    const debouncedUpdateBillTosSearchFields = debounce((value: string) => {
        updateBillTosSearchFields({ ...getBillTosParameter, filter: value || undefined });
    }, 200);

    const selectCustomerHandler = (customerId?: string) => {
        updateSearchFields({
            customerNumber: customerId === EMTPY_ID ? EMTPY_ID : customerId,
        } as GetInvoicesApiParameter);

        //  updateSearchFields({ customerNumber: customerId } as GetOrdersApiParameter);
    };

    const getBillToOptions = () => {
        const options: OptionObject[] =
            billTosDataView?.value?.map(billTo => ({
                optionText: billTo.label,
                optionValue: billTo.customerNumber,
            })) || [];
        options.unshift({ optionText: translate("Show All"), optionValue: EMTPY_ID });

        return options;
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper
                css={css`
                    width: 50%;
                    max-width: 1440px;
                `}
            >
                <DynamicDropdown
                    label={translate("Select Customer Account")}
                    {...styles.billToSelectorDynamicDropdown}
                    onSelectionChange={selectCustomerHandler}
                    onInputChange={changeCustomerSearchTextHandler}
                    selected={(parameter as any).customerNumber || EMTPY_ID}
                    isLoading={billTosDataView?.isLoading}
                    options={billToOptions}
                    search={billToSearch}
                    data-test-selector="changeCustomerBillToSelectorInvoiceHistory"
                    placeholder={translate("Search or Select Bill To")}
                    filterOption={() => true}
                />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(InvoiceHistorySearchFieldBillTo),
    definition: {
        group: "Invoice History",
        displayName: "Invoice History Bill To",
        allowedContexts: ["InvoiceHistoryPage"],
    },
};

export default widgetModule;
